import GroupView from './GroupView'; 

export default GroupView;